import { HttpError } from "react-admin";

function extractErrorMessage(err: unknown): string {
  // react-admin/ra-core HttpError (fetchUtils)
  if (err instanceof HttpError) {
    const bodyMsg =
      (typeof err.body === "object" &&
        err.body &&
        "message" in err.body &&
        typeof (err.body as { message: unknown }).message === "string" &&
        (err.body as { message: string }).message) ||
      undefined;

    return bodyMsg ?? err.message ?? `HTTP ${err.status}`;
  }

  // Standard Error
  if (err instanceof Error) return err.message;

  // String thrown
  if (typeof err === "string") return err;

  // { message: string } shape
  if (
    typeof err === "object" &&
    err !== null &&
    "message" in err &&
    typeof (err as { message: unknown }).message === "string"
  ) {
    return (err as { message: string }).message;
  }

  try {
    return JSON.stringify(err);
  } catch {
    return "Unknown error";
  }
}
export { extractErrorMessage };
